import * as serviceWorker from './base/serviceWorker';

import { createRoot } from 'react-dom/client';

import { initGTM } from './base/utils/tracking';
import { config as siteConfig } from './config';
import AppContainer from './base/components/AppContainer';

if (typeof siteConfig['google.gtm'] !== 'undefined') initGTM(siteConfig['google.gtm']);

const root = createRoot(document.getElementById('root'));

// Stylesheets
import './base/assets/scss/libs.scss';

root.render(<AppContainer />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
